// Configurações de Webhooks para n8n
// Este arquivo centraliza todas as URLs de webhook para facilitar o gerenciamento

const WEBHOOK_CONFIG = {
  // URL do webhook principal do n8n para captura de leads
  // IMPORTANTE: Substitua pela URL real do seu webhook do n8n
  LEAD_CAPTURE: process.env.REACT_APP_N8N_WEBHOOK_URL || 'https://seu-n8n-instance.com/webhook/lead-capture',
  
  // Webhook específico para a página do SbxElliot
  // Pode ser configurado via variável de ambiente ou usa URL padrão
  SBX_ELLIOT_CAPTURE: process.env.REACT_APP_N8N_WEBHOOK_URL_SBX_ELLIOT || 'https://hookauto.nucleodeperformance.com.br/webhook/form-pg-captura-elliot',
  
  // Configurações adicionais
  TIMEOUT: 10000, // 10 segundos
  RETRY_ATTEMPTS: 3,
  
  // Headers padrão
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

// Função para enviar dados para o webhook do n8n
export const sendToN8nWebhook = async (data, webhookType = 'LEAD_CAPTURE') => {
  const webhookUrl = WEBHOOK_CONFIG[webhookType];
  
  if (!webhookUrl || webhookUrl.includes('seu-n8n-instance.com')) {
    console.warn('⚠️ URL do webhook do n8n não configurada. Verifique o arquivo webhooks.js');
    throw new Error('Webhook URL não configurada');
  }

  console.log('🚀 Enviando dados para webhook:', webhookUrl);
  console.log('📦 Dados a serem enviados:', data);

  try {
    // Criar um AbortController para timeout manual (mais compatível)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), WEBHOOK_CONFIG.TIMEOUT);

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        ...WEBHOOK_CONFIG.DEFAULT_HEADERS,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST, OPTIONS',
        'Access-Control-Allow-Headers': 'Content-Type'
      },
      body: JSON.stringify(data),
      signal: controller.signal,
      mode: 'cors'
    });

    clearTimeout(timeoutId);

    console.log('📡 Resposta do webhook - Status:', response.status);
    console.log('📡 Resposta do webhook - Headers:', response.headers);

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Erro desconhecido');
      console.error('❌ Erro HTTP:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const result = await response.json().catch(() => ({ message: 'Dados enviados com sucesso' }));
    console.log('✅ Dados enviados com sucesso para o n8n:', result);
    
    return { success: true, data: result };
  } catch (error) {
    console.error('❌ Erro detalhado ao enviar dados para o n8n:', {
      message: error.message,
      name: error.name,
      stack: error.stack
    });
    
    // Melhor tratamento de diferentes tipos de erro
    if (error.name === 'AbortError') {
      throw new Error('Timeout: O webhook demorou muito para responder');
    } else if (error.message.includes('Failed to fetch')) {
      throw new Error('Erro de conexão: Verifique sua internet ou se o webhook está acessível');
    } else {
      throw error;
    }
  }
};

// Função para validar se o webhook está configurado
export const isWebhookConfigured = (webhookType = 'LEAD_CAPTURE') => {
  const webhookUrl = WEBHOOK_CONFIG[webhookType];
  return webhookUrl && !webhookUrl.includes('seu-n8n-instance.com');
};

// Função para obter informações de UTM da URL
export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_term: urlParams.get('utm_term') || '',
    utm_content: urlParams.get('utm_content') || ''
  };
};

// Função para preparar dados do formulário para envio
export const prepareFormData = (formData, additionalData = {}) => {
  const utmParams = getUtmParams();
  
  return {
    // Dados do formulário
    nome: formData.nome?.trim() || '',
    email: formData.email?.trim().toLowerCase() || '',
    telefone: `${formData.countryCode} ${formData.whatsapp}`,
    telefone_limpo: formData.whatsapp?.replace(/\D/g, '') || '',
    pais: formData.countryCode || '+55',
    
    // Metadados
    timestamp: new Date().toISOString(),
    source: 'landing-page-hero',
    user_agent: navigator.userAgent,
    url: window.location.href,
    referrer: document.referrer || '',
    
    // Parâmetros UTM
    ...utmParams,
    
    // Dados adicionais
    ...additionalData
  };
};

export default WEBHOOK_CONFIG;